import { useState, useEffect, useContext} from "react";
import ModalConfirm from "../UI/ModalConfirm";
import { ActionInfo, ActionConfirmInfo, ActionColor } from "./RentalItem";
import { DATABASE_MAIN } from "../contexts/api";
import { useTranslation } from "react-i18next";
import "../localization/i18n";
import { format } from "date-fns";
import AuthContext from "../contexts/auth";

const RentalConfirm = (props) => {
  const { t } = useTranslation();
  const authCtx = useContext(AuthContext);
  //const [fromDate, setFromDate] = useState(new Date(props.item.fromDate));
  //const [toDate, setToDate] = useState(new Date(props.item.toDate));
  const [actionState, setActionState] = useState(props.item.state);

  useEffect(() => {
    if (props.item.state === "0") 
      setActionState("1");
     else 
      setActionState("0");
  }, [props.item.state, t]);

  const onConfirm = () => {
    
    let item = {};
    let itemLog = {};
  
    if (props.item.state === "0"){
      item = {
        id: props.item.id,
        state: actionState,
        rentier: authCtx.name,
        lastRentier: props.item.lastRentier,
        place: props.item.place,
        name: props.item.name,
        description: props.item.description,
        fromDate: new Date().toISOString(),
        toDate: null,
      };
      itemLog = {
        state: actionState,
        rentier: authCtx.name,
        name: props.item.name,
        fromDate: format(new Date(), "dd.MM.yyyy"),
        toDate: "",
      };
    }
    else {
      item = {
        id: props.item.id,
        state: actionState,
        rentier: "",
        lastRentier: props.item.rentier,
        place: props.item.place,
        name: props.item.name,
        description: props.item.description,
        fromDate: new Date(props.item.fromDate),
        toDate: new Date().toISOString(),
      };
      itemLog = {
        state: actionState,
        rentier: authCtx.name,
        name: props.item.name,
        fromDate: format(new Date(props.item.fromDate), "dd.MM.yyyy"),
        toDate: format(new Date(), "dd.MM.yyyy"),
      };

    }
    //console.log(JSON.stringify(item));
    updateItem(item);
    addlog(itemLog);
    props.onClose(item);    
  };

  async function updateItem(rentAction) {
    await fetch(`${DATABASE_MAIN}/updateRentalItem.php`, {
      method: "POST",
      body: JSON.stringify(rentAction),
      /* headers: {
        "content-type": "application/json",
      }, */
      mode: 'no-cors',
    }).catch((error) => console.log(error));
  }

  async function addlog(item) {

    const url = "https://script.google.com/macros/s/AKfycbwHpwNvinb_uPkDU41_MWHxu22J2uDILeSVFk-O6zZol9kiEnzl2CYzRsLxzBtzAstQ4A/exec";

//"Access-Control-Allow-Headers": "Content-Type"
    fetch(url,{
      method: "POST",
      headers: {
      //  "Content-type": "application/json",
        "Content-type": "application/x-www-form-urlencoded",
      //"Access-Control-Allow-Origin": "*",
      //"Access-Control-Allow-Methods": "POST",
      },
      body: (`Name=${item.name}&Nick=${item.rentier}&Date=${item.fromDate}&DateTo=${item.toDate}&State=${item.state}`),
      //body: JSON.stringify(item),
      mode: "no-cors",
    }).catch((error) => console.log(error));
  }

  return (
    <ModalConfirm onClose={props.onClose}>
        <div className="row">
            <div className="col-sm">
                <h2 className="">{props.item.name}</h2>
                <h5>{t("rentState")}: {ActionInfo(props.item.state)}</h5>
            </div>
            <div className="col-sm">
                <img
                    className="rounded mx-auto p-2"
                    src={`${DATABASE_MAIN}/rentalImage.php?id=${props.item.id}`}
                    alt={props.item.name} />
            </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-auto">
                <p><b>{authCtx.name}</b>, opravdu to myslíš vážně?</p>
          </div>
        </div>   
        <div className="row justify-content-md-center">
            <div className="col-md-auto" >
                <button className={`btn btn-outline-${ActionColor(props.item.state)}`} onClick={onConfirm}>{ActionConfirmInfo(props.item.state)}</button>
                <button className="btn btn-outline-primary" onClick={props.onClose}>{t("close")}</button>
            </div>
        </div>
    </ModalConfirm>
  );
};

export default RentalConfirm;
